// extracted by mini-css-extract-plugin
module.exports = {"moduleCardMenuContainer":"styles_moduleCardMenuContainer__373c4","moduleCardMenu":"styles_moduleCardMenu__3HR5C","darkMenu":"styles_darkMenu__3z6XH"};